import React from "react";
import { CODIFF_LINKS_STORAGE_KEY } from "../constants";
import { useLocalStorage } from "./useLocalStorage";

const CodiffLinksContext = React.createContext(null);

const noop = () => {};
const FALLBACK = [false, noop];

// Whether MR links should point at Codiff instead of GitLab.
//
// The setting is read by every MR card and every copy button, so backing each
// consumer with its own useLocalStorage would mean N localStorage writes and an
// N-listener broadcast storm on a board with N rows. One provider owns the
// storage; consumers just subscribe.
export const CodiffLinksProvider = ({ children }) => {
	const [useCodiffLinks, setUseCodiffLinks] = useLocalStorage(
		CODIFF_LINKS_STORAGE_KEY,
		false,
	);

	const value = React.useMemo(
		() => [useCodiffLinks, setUseCodiffLinks],
		[useCodiffLinks, setUseCodiffLinks],
	);

	return (
		<CodiffLinksContext.Provider value={value}>
			{children}
		</CodiffLinksContext.Provider>
	);
};

// Returns [useCodiffLinks, setUseCodiffLinks]. Falls back to the default when
// rendered outside a provider (e.g. an isolated component test).
export const useCodiffLinks = () => {
	const value = React.useContext(CodiffLinksContext);
	return value ?? FALLBACK;
};
